module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/dollar-sign.svg?728f733dfb9722895b3e250e4799d44c";